// Build-time tenant flag. `true` only in the broker-admin build
// (admin.broker-ai.org — `.env.*-broker-admin` sets VITE_IS_BROKER_ADMIN=true);
// the internal Intelligent-Automation admin build leaves it unset.
//
// Single source of truth — import this rather than re-declaring the
// `import.meta.env.VITE_IS_BROKER_ADMIN === 'true'` expression per file
// (so a future change to the detection logic lands in one place).
export const IS_BROKER_ADMIN = import.meta.env.VITE_IS_BROKER_ADMIN === 'true';

// Master kill-switch for the testing-org → billable-org Conversion Requests
// queue, paired with the backend CONVERSION_CAPTURE_ENABLED_STACKS env flag.
// Default OFF (unset) so the whole mechanism ships dark — the queue nav item +
// route are hidden until this is set to 'true' (in `.env.*-broker-admin`) at the
// same time the backend flag is flipped to 'broker-ai'.
export const IS_CONVERSION_REQUESTS_ENABLED =
  import.meta.env.VITE_ENABLE_CONVERSION_REQUESTS === 'true';
